export default function paginationTemplate({ items }: { items: boolean[] }) {
  return `<div class="fra-m-slider__pagination fra-js-slider__pagination">
  ${items
    .map(
      (_, index) => `
  <span class="fra-m-slider__pagination-item fra-js-slider__pagination-item ${
    index === 0 ? "fra-m-slider__pagination-item--active" : ""
  }" data-fra-index="${index}"></span>
  `,
    )
    .join("\n")}
</div>
  `;
}
